import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookSelectFormGroup } from "components";
import { HasPermissions } from "components/hasPermissions";
import { DebounceTimeout } from "globalConstants";
import { permissionList } from "helpers";
import { BillingStatusTypes } from "types";

type BillingStatusFieldProps = {
	isLoading: boolean;
	sectionName: string;
	index: number;
	defaultValue: { [key: string]: any };
};

const BillingStatusField = ({
	isLoading,
	sectionName,
	index,
	defaultValue,
}: BillingStatusFieldProps) => {
	const { setValue } = useFormContext();

	const handleBillingStatusChange = option => {
		if (option.value === BillingStatusTypes.invoice_created.value) {
			setValue(
				`${sectionName}.${index}.paymentTypeInfo.invoiceDate`,
				new Date(),
			);
		}

		if (option.value === BillingStatusTypes.payment_received.value) {
			setValue(
				`${sectionName}.${index}.paymentTypeInfo.paymentDate`,
				new Date(),
			);
		}
	};

	return (
		<HasPermissions requiredPermissions={permissionList.EquipmentBilling}>
			<Row className="form-group">
				<Col md={5}>
					<HookSelectFormGroup
						label="Billing Status"
						name={`${sectionName}.${index}.paymentTypeInfo.billingStatus`}
						options={BillingStatusTypes.getOptions()}
						getOptionLabel={option => option.displayName}
						getOptionValue={option => option.value}
						onChange={handleBillingStatusChange}
						placeholder="Please Select"
						defaultValue={defaultValue?.billingStatus}
						isSearchable={false}
						debounceTimeout={DebounceTimeout}
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</HasPermissions>
	);
};

export default BillingStatusField;
